<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/tags"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <TagsFormulario @send="editar" :tag="tag" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Tag editada com sucesso"
      @close="goToTags"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { editarTag, exibirTag } from "@/services/tags";
import TagsFormulario from "@/components/tags/TagsFormulario.vue";
export default {
  name: "TagsEditar",
  components: { TagsFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Tags",
        disabled: false,
        to: "/tags",
      },
      {
        text: "Editar Tag",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    tag: {},
    loading: false
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  created() {
    this.exibir();
  },
  methods: {
    async editar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await editarTag(this.$route.params.id, event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    async exibir() {
      this.error = false;
      this.loading = true;
      try {
        const resp = await exibirTag(this.$route.params.id);
        this.tag = resp.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.messageError =  e.response.data.message;
      }
    },
    goToTags() {
      this.sucess = false;
      this.$router.push({ name: "Tags" });
    },
  },
};
</script>

<style></style>
